import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function MobilePayment(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "MobilePayment", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M30.7501 11.2499h-13.5V2.99991c0-.45.3-.75.75-.75h12c.45 0 .75.3.75.75v8.24999Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M23.25 2.25h-3v9h3v-9Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.5001 5.99994h-2.25c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h2.25c.45 0 .75.3.75.75s-.3.75-.75.75Zm0 2.25h-2.25c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h2.25c.45 0 .75.3.75.75s-.3.75-.75.75Zm0 1.5h-2.25c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h2.25c.45 0 .75.3.75.75s-.3.75-.75.75Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M34.3948 15.7448h-21v25.4999h21V15.7448Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.9198 35.9734c4.1518 0 7.5175-3.3657 7.5175-7.5175 0-4.1517-3.3657-7.5174-7.5175-7.5174s-7.5175 3.3657-7.5175 7.5174c0 4.1518 3.3657 7.5175 7.5175 7.5175Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.384 27.9851v-1.8832c.2465 0 .4829.0992.6572.2758.1743.1766.2722.4161.2722.6658 0 .1249.049.2446.1361.3329.0872.0883.2054.1379.3286.1379.1233 0 .2415-.0496.3286-.1379.0872-.0883.1362-.208.1362-.3329 0-.4995-.1959-.9784-.5445-1.3316-.3486-.3532-.8214-.5516-1.3144-.5516v-.4708c0-.1248-.049-.2446-.1361-.3329-.0872-.0882-.2054-.1378-.3286-.1378-.1233 0-.2415.0496-.3286.1378-.0872.0883-.1361.2081-.1361.3329v.4708c-.493 0-.9658.1984-1.3144.5516-.3487.3532-.5445.8321-.5445 1.3316 0 .4994.1958.9784.5445 1.3316.3486.3532.8214.5516 1.3144.5516v1.8831c-.2465 0-.4829-.0992-.6572-.2758-.1743-.1765-.2723-.416-.2723-.6658 0-.1248-.0489-.2446-.1361-.3329-.0871-.0883-.2053-.1379-.3286-.1379-.1232 0-.2414.0496-.3286.1379-.0871.0883-.1361.2081-.1361.3329 0 .4995.1958.9785.5445 1.3316.3486.3532.8214.5516 1.3144.5516v.4708c0 .1249.0489.2446.1361.3329.0871.0883.2053.1379.3286.1379.1232 0 .2414-.0496.3286-.1379.0871-.0883.1361-.208.1361-.3329v-.4708c.493 0 .9658-.1984 1.3144-.5516.3486-.3531.5445-.8321.5445-1.3316 0-.4994-.1959-.9784-.5445-1.3316-.3486-.3531-.8214-.5515-1.3144-.5515Zm-1.8589-.9416c0-.2497.098-.4892.2723-.6658.1743-.1766.4107-.2758.6572-.2758v1.8832c-.2465 0-.4829-.0992-.6572-.2758-.1743-.1766-.2723-.4161-.2723-.6658Zm1.8589 3.7663v-1.8831c.2465 0 .4829.0992.6572.2757.1743.1766.2722.4161.2722.6658 0 .2498-.0979.4893-.2722.6658-.1743.1766-.4107.2758-.6572.2758ZM34.4999 15.75h-21v-3c0-.825.675-1.5 1.5-1.5h18c.825 0 1.5.675 1.5 1.5v3Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M25.4999 14.2499h-3c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h3c.45 0 .75.3.75.75s-.3.75-.75.75Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M32.9999 45.7499h-18c-.825 0-1.5-.675-1.5-1.5v-3h21v3c0 .825-.675 1.5-1.5 1.5Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M25.4999 44.25h-3c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h3c.45 0 .75.3.75.75s-.3.75-.75.75Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
MobilePayment.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "MobilePayment"
};
validateTidalLicense();
export {
  MobilePayment
};
//# sourceMappingURL=MobilePayment.js.map
